import * as React from 'react';
import { SvgIcon } from '../../icons/SvgIcon';

interface IProps {
	className?: string;
}

export const BookOfBusinessHealthIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`book-of-business-health-icon ${className || ''}`} height={689} width={689}>
			<mask id='book-of-business-health-mask' fill='white'>
				<circle cx='344.5' cy='344.5' r='344.5' />
			</mask>
			<circle cx='344.5' cy='344.5' r='344.5' fill='#FFF0E4' />
			<g id='undraw_notebook_re_id0r' mask='url(#book-of-business-health-mask)'>
				<g transform='translate(-3.000000, 167.000000)'>
					<path
						d='M674.970221,401.024503 C674.766349,408.656181 673.491574,416.221009 671.183471,423.496014 C671.132293,423.664855 671.075479,423.831158 671.020227,424 L656.889993,424 C656.904825,423.848606 656.920172,423.679731 656.935029,423.496014 C657.877117,412.633091 652.494797,347.306342 646,336 C646.56902,336.917155 676.065825,366.508085 674.970221,401.024503 Z'
						id='b2aec908-dac2-485e-9341-1f8763a52ddc-127'
						fill='#F1F1F1'
						fillRule='nonzero'
					/>
					<path
						d='M673.953691,423.490378 C673.835635,423.661107 673.712969,423.831863 673.587245,424 L663,424 C663.080241,423.854674 663.173247,423.683944 663.281074,423.490378 C665.029954,420.285238 670.206548,410.70206 675.011615,400.767566 C680.173371,390.09144 684.912985,379.010531 684.51388,375 C684.637557,375.904002 688.210923,403.478638 673.953691,423.490378 Z'
						id='bc80851e-3fc6-46a5-adb1-be50bb758626-128'
						fill='#F1F1F1'
						fillRule='nonzero'
					/>
					<path
						d='M7.02259029,406.76838 C7.17725632,412.492138 8.14432995,418.165758 9.89530696,423.622011 C9.93408693,423.748637 9.97717578,423.873366 10.0191443,424 L20.7386257,424 C20.7273709,423.886456 20.7157283,423.759797 20.7044649,423.622011 C19.9897759,415.474825 24.0729102,366.47976 29,358 C28.5683272,358.687867 6.19144938,380.881088 7.02259029,406.76838 Z'
						id='ac74e0d2-c10f-4860-b119-67c8c5820ae0-129'
						fill='#F1F1F1'
						fillRule='nonzero'
					/>
					<path
						d='M8.0336644,423.625585 C8.11951663,423.751013 8.20873528,423.876476 8.30017347,424 L16,424 C15.9416403,423.893226 15.8740064,423.767797 15.7955801,423.625585 C14.5236718,421.270794 10.7588805,414.230081 7.2642948,406.931273 C3.51027117,399.087585 0.0632692824,390.946511 0.35355789,388 C0.263588389,388.664165 -2.33522157,408.923075 8.0336644,423.625585 Z'
						id='b887613c-750d-48e2-8424-1e5e637b4506-130'
						fill='#F1F1F1'
						fillRule='nonzero'
					/>
					<path
						d='M524,299 C444.117781,265.1581 371.847875,266.444465 303.775432,287.1 C198.890267,268.788552 127.069169,271.621789 81,299 L81,214 L524,214 L524,299 Z'
						id='Path'
						fill='#CBCBCB'
						fillRule='nonzero'
					/>
					<path
						d='M525,275 C451.310269,241.687887 377.709909,239.537221 303,275 C226.478809,253.018584 152.504723,253.248463 81,275 L81,16.7760442 C157.024038,-5.86182147 230.975631,-5.31781834 303,16.7760442 C379.081362,-5.24150637 453.147774,-5.93979831 525,16.7760442 L525,275 Z'
						id='Path'
						fill='#E5E5E5'
						fillRule='nonzero'
					/>
					<path
						d='M100.473618,49 L98,42.6024816 C98.9695101,42.2197463 122.135662,33.1699011 156.134055,28.553596 C187.566679,24.284809 234.39743,23.2657182 279,42.6460781 L276.315073,48.9559829 C233.2039,30.2241353 187.757929,31.2105331 157.224185,35.3355324 C123.989805,39.8264913 100.704902,48.9086174 100.473618,49 Z'
						id='Path'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M100.473618,73 L98,66.6024024 C98.9695101,66.2196623 122.135662,57.169705 156.134055,52.5533427 C187.566679,48.2849236 234.39743,47.2658202 279,66.6459994 L276.315073,72.9559823 C233.2039,54.2239028 187.757929,55.2094714 157.224185,59.3353632 C123.989805,63.8263777 100.704902,72.9086163 100.473618,73 Z'
						id='Path'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M100.473618,97 L98,90.6024816 C98.9695101,90.2197463 122.135662,81.1699011 156.134055,76.553596 C187.566679,72.284809 234.39743,71.2657182 279,90.6460781 L276.315073,96.9559829 C233.2039,78.2241353 187.757929,79.2096917 157.224185,83.3355324 C123.989805,87.8264913 100.704902,96.9086174 100.473618,97 Z'
						id='Path'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M100.473618,120 L98,113.602405 C98.9695101,113.219665 122.135662,104.169711 156.134055,99.553351 C187.566679,95.2853543 234.39743,94.2649892 279,113.646002 L276.315073,119.955982 C233.2039,101.22391 187.757929,102.209899 157.224185,106.335369 C123.989805,110.826381 100.704902,119.908616 100.473618,120 Z'
						id='Path'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M100.473618,144 L98,137.602482 C98.9695101,137.219746 122.135662,128.169901 156.134055,123.553596 C187.566679,119.284809 234.39743,118.265718 279,137.646078 L276.315073,143.955983 C233.2039,125.223715 187.757929,126.210112 157.224185,130.335532 C123.989805,134.826491 100.704902,143.908617 100.473618,144 Z'
						id='Path'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M100.473618,168 L98,161.602378 C98.9695101,161.219636 122.135662,152.169644 156.134055,147.553264 C187.566679,143.285249 234.39743,142.2653 279,161.645975 L276.315073,167.955982 C233.2039,149.22341 187.757929,150.210244 157.224185,154.33531 C123.989805,158.826342 100.704902,167.908616 100.473618,168 Z'
						id='Path'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M322.473618,218 L320,211.602378 C320.96951,211.219636 344.135662,202.169644 378.134055,197.553264 C409.566679,193.285249 456.39743,192.2653 501,211.645975 L498.315073,217.955982 C455.2039,199.22341 409.757929,200.210244 379.224185,204.33531 C345.989805,208.826342 322.704902,217.908616 322.473618,218 Z'
						id='Path'
						fill='#D0021B'
						fillRule='nonzero'
					/>
					<path
						d='M321,172 L321,41.9201428 L323.391472,41.1742214 C383.995032,22.2715205 444.304729,22.2752631 502.644723,41.1854321 L505,41.948799 L505,171.826804 L500.38948,170.089056 C439.678399,147.209628 380.908526,147.195916 325.71264,170.048773 L321,172 Z M410.924241,146.099485 C439.448586,146.099485 468.535567,151.408588 498.185185,162.026794 L498.185185,46.9052914 C442.717491,29.438788 385.419635,29.4483401 327.814815,46.9331141 L327.814815,161.868968 C354.282929,151.456563 382.476006,146.107107 410.924241,146.099485 L410.924241,146.099485 Z'
						id='Shape'
						fill='#FFFFFF'
						fillRule='nonzero'
					/>
					<path
						d='M498,215 L498.88432,193.439706 L529.220384,132.896129 C530.075734,131.174866 531.470339,129.783042 533.190018,128.934408 C535.317418,127.869199 537.782236,127.707654 540.029562,128.486143 C542.641488,129.39022 544.682898,131.466908 545.548609,134.100565 C545.731562,134.661583 545.860232,135.238993 545.932833,135.824789 C546.148471,137.563304 545.842164,139.326858 545.053146,140.889553 L514.675898,201.515115 L498,215 Z'
						id='Path'
						fill='#D0021B'
						fillRule='nonzero'
					/>
					<path
						d='M537,128 L503.550327,194 L501,192.727046 L533.351866,128.89311 C534.485842,128.329847 535.732157,128.024733 537,128 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M545,135.644341 L513.497078,199 L511,197.729635 L543.683364,132 C544.08568,132.620231 544.405879,133.291131 544.635779,133.995555 C544.80937,134.532011 544.931343,135.084168 545,135.644341 L545,135.644341 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M542,129.354823 L508.524395,196 L506,194.728656 L539.517497,128 C539.874694,128.122342 540.223051,128.269176 540.560093,128.43946 C541.068994,128.696358 541.551305,129.002967 542,129.354823 L542,129.354823 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M501,211.344914 L498,214 L498.251479,207 C499.281508,207.39268 500.396676,209.096601 501,211.344914 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M168.063573,289 L164,276.810326 L168.329117,236.72839 C168.448178,235.590347 168.941708,234.522421 169.733913,233.68862 C170.710689,232.648579 172.069406,232.040763 173.504178,232.00201 C175.171576,231.956569 176.764756,232.683868 177.811406,233.968291 C178.033542,234.242201 178.228469,234.536644 178.393481,234.847539 C178.883294,235.770163 179.083448,236.816387 178.968305,237.8522 L174.633365,277.988465 L168.063573,289 Z'
						id='Path'
						fill='#D0021B'
						fillRule='nonzero'
					/>
					<path
						d='M172,232 L167.585052,276 L166,275.81978 L170.270052,233.263831 C170.751223,232.710836 171.342226,232.279072 172,232 L172,232 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M178,234.762538 L173.630791,277 L172,276.820144 L176.532924,233 C176.8805,233.261962 177.193317,233.569841 177.463382,233.915768 C177.668237,234.17953 177.847944,234.463103 178,234.762538 L178,234.762538 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M175,232.234318 L170.57228,276 L169,275.8227 L173.433314,232.002191 C173.644469,231.995492 173.85581,232.004158 174.065837,232.028128 C174.382896,232.064215 174.695803,232.133281 175,232.234318 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<path
						d='M170,286.807338 L168.518346,289 L167,285.000358 C167.824869,284.981866 169.027769,285.68181 170,286.807338 Z'
						id='Path'
						fill='#3F3D56'
						fillRule='nonzero'
					/>
					<g
						id='f2202155-5d0d-4949-a3af-453985752dd6'
						strokeWidth='1'
						fill='none'
						fillRule='evenodd'
						transform='translate(506.000000, 120.000000)'
					>
						<path
							d='M100.745183,155.122912 C98.8134676,158.51028 94.5087069,159.686198 91.1302306,157.749399 C87.7517544,155.8126 86.5789229,151.49651 88.5106381,148.109142 C88.5263513,148.081608 88.5422454,148.054165 88.5583206,148.026813 C88.7553816,147.69571 88.9772757,147.380115 89.2220828,147.082759 L83.2945986,104.72278 L83.1170874,103.453674 L81.9130623,94.8098726 L81.7355511,93.5639984 L82.3915925,93.594963 L93.8761139,94.1211655 L96.9556302,94.2604552 L97.3415359,102.145879 L99.5257585,146.479136 C101.874541,148.732219 102.378596,152.305067 100.745217,155.122912 L100.745183,155.122912 Z'
							id='bb56e1bb-a377-463a-b777-e3f2ac15f40f-131'
							fill='#FFB8B8'
							fillRule='nonzero'
						/>
						<path
							d='M83.1510251,103.837474 L97.734348,102.496409 C99.3086746,102.34681 100.467917,100.951994 100.33071,99.3724296 L97.6293786,68.9667256 C97.0863622,62.8683382 91.7154178,58.3659787 85.6330384,58.9104241 C79.5506591,59.4548695 75.060118,64.8399494 75.603134,70.9383368 C75.6217998,71.1477278 75.6463707,71.3564496 75.6768467,71.5645022 L80.0499074,101.388293 C80.2575019,102.800482 81.4649227,103.847494 82.8886188,103.850186 C82.9762626,103.851405 83.0639135,103.847262 83.1510251,103.837474 L83.1510251,103.837474 Z'
							id='a248d591-cba6-4901-9d10-c9b24d625163-132'
							fill='#CBCBCB'
							fillRule='nonzero'
						/>
						<path
							d='M94.2048685,79.2734962 C97.2359351,70.6651305 94.1828559,61.0861465 86.7345335,55.8354477 C81.2354026,52.0629814 73.7102752,50.7087566 65.6062807,60.3817568 C55.7994692,72.1905864 48.8048384,86.0843441 45.1533629,101.00833 L78.3411182,106.425204 C78.3411182,106.425204 89.6272737,92.5928074 94.2048685,79.2734962 Z'
							id='f743e301-5bba-4392-b658-4efdfb4065cc-133'
							fill='#CBCBCB'
							fillRule='nonzero'
						/>
						<polygon
							id='eac80286-6d9c-481f-b372-04b3b845d333-134'
							fill='#FFB8B8'
							fillRule='nonzero'
							points='40.5279584 297.191372 31.0655561 297.191372 26.5643636 260.598022 40.5294601 260.598022'
						/>
						<path
							d='M12.8192174,306 L42.5577729,306 L42.5577729,294.479851 L24.3091264,294.479851 C17.9634249,294.479851 12.8192174,299.637597 12.8192174,306 L12.8192174,306 Z'
							id='e474a022-de70-4f17-bf9b-ca694d09b1b4-135'
							fill='#2F2E41'
							fillRule='nonzero'
						/>
						<polygon
							id='a9ae19c7-51aa-4dd0-9022-ef91b49440e0-136'
							fill='#FFB8B8'
							fillRule='nonzero'
							points='118.321566 288.916704 109.337719 291.89446 93.608269 258.566685 106.867936 254.172034'
						/>
						<path
							d='M94.7682429,305.999915 L123.004418,296.642601 L119.398537,285.70445 L102.071816,291.446426 C96.0467004,293.443123 92.7767691,299.958939 94.7682175,305.999915 L94.7682429,305.999915 Z'
							id='bdf88be3-aecd-443e-97f8-a32ede953949-137'
							fill='#2F2E41'
							fillRule='nonzero'
						/>
						<ellipse
							id='e601451a-496c-4b1c-9fe2-c3a71e9d5111'
							fill='#FFB8B8'
							fillRule='nonzero'
							cx='73.3714495'
							cy='27.2343163'
							rx='18.9563835'
							ry='19.0062744'
						/>
						<path
							d='M56.7737115,287.005312 L65.5607448,228.855115 C65.7541991,227.575313 66.8238077,226.611642 68.1135951,226.555108 C69.4033824,226.498574 70.5527864,227.364981 70.8568942,228.622974 L84.2385336,284.039176 C84.6754987,285.798737 86.377981,286.934383 88.1654746,286.658653 L125.077223,280.710941 C126.067513,280.551573 126.940744,279.970766 127.472233,279.117964 C128.003721,278.265162 128.141572,277.223632 127.850316,276.261362 L79.7195917,117.159907 C79.582986,116.707671 79.5667553,116.227472 79.6725116,115.767002 L81.2747873,108.802443 C81.6369478,107.248922 80.8959047,105.647991 79.4787867,104.922408 C72.9245662,101.569351 56.3245374,94.5986073 43.7973138,102.234086 C42.9754799,102.736737 42.395422,103.555548 42.1927303,104.499121 L4.59328474,281.68516 C4.38637445,282.659757 4.60577907,283.676536 5.19598294,284.478222 C5.78618681,285.279908 6.69064237,285.789692 7.68049648,285.878583 L53.0296438,289.950547 C53.1325373,289.959802 53.2354421,289.964481 53.3383582,289.964481 C55.0540512,289.961443 56.5114253,288.704892 56.7713613,287.004538 L56.7737115,287.005312 Z'
							id='fd5880a1-dddd-4cd5-886d-5f97a9f21c4e-138'
							fill='#2F2E41'
							fillRule='nonzero'
						/>
						<path
							d='M85.9411207,13.8058803 C84.5122095,12.9440627 83.2441681,11.8389676 82.1939987,10.5402722 C81.1394967,9.20581308 80.8557056,7.41646674 81.4453412,5.81987233 C82.4031568,3.70109419 85.2488084,3.03404529 87.4546408,3.75295989 C89.6604732,4.47187449 91.3638494,6.20757632 92.9753816,7.87985176 C94.3947415,9.35014274 95.8549963,10.8916353 96.5257073,12.825451 C97.1964183,14.7592667 96.8529517,17.2115353 95.1781256,18.3854678 C93.5341744,19.536951 91.1709304,19.0656767 89.5902306,17.8291259 C88.0976625,16.4770051 86.9074364,14.8234461 86.0978026,12.9771605 L85.9411207,13.8058803 Z'
							id='acdc6559-e36c-4b0b-aac1-c1a10856fa7d-139'
							fill='#2F2E41'
							fillRule='nonzero'
						/>
						<path
							d='M92.3617877,8.39056346 C92.4667571,3.0355595 98.5547836,-0.804969382 103.813118,0.144520884 C109.071452,1.09401115 113.112628,5.58848852 115.135544,10.5457335 C119.409812,21.0196534 116.201409,32.9708313 112.083042,43.511308 C107.964676,54.0517848 102.867647,64.7446856 103.468888,76.0458452 C104.297372,88.4892829 111.855683,99.4786366 123.161575,104.67789 C117.227915,107.374711 110.134992,104.588901 105.148338,100.384623 C94.0744628,91.0482439 89.8001608,74.4254014 94.9905774,60.8847443 C97.5506601,54.2057316 102.062645,48.4917169 105.585193,42.2692619 C109.10774,36.0468068 111.692504,28.713131 109.873358,21.7942532 C108.054212,14.8753754 100.314505,9.27428798 93.6977966,11.9509818 L92.3617877,8.39056346 Z'
							id='a8902353-3630-4aaa-9386-a524a4077d2f-140'
							fill='#2F2E41'
							fillRule='nonzero'
						/>
						<path
							d='M72.2345871,35.6684092 C73.8870312,32.8686481 75.5533644,29.1929121 72.5340874,26.7452628 C71.2073023,25.7191498 69.523902,25.2727788 67.8646487,25.5071127 C64.4594236,25.9188398 60.7508888,26.0882688 57.4544935,24.847839 C54.9567081,23.9860017 52.9140833,22.1457357 51.7932676,19.7474593 C50.095296,15.7049204 52.2223929,10.7925996 55.7796589,8.23737377 C60.2293743,5.15729716 66.0874545,5.05329539 70.6431376,7.97349414 C75.2508351,5.9328846 80.8410379,6.84059818 85.0273224,9.64962314 C89.2136069,12.4586481 92.0777885,16.956979 93.6337562,21.7602092 C95.0671866,25.894579 95.3140162,30.3494238 94.3461427,34.6175439 C92.7655183,40.6434313 88.3537992,45.5181413 82.525095,47.6791599 C80.2484725,48.5795279 77.6659123,48.196231 75.7470808,46.6731848 C74.2146842,45.2951678 73.0378517,43.5656277 72.3171661,41.6323864 C71.6881391,39.5143739 71.3524018,37.164229 72.2345871,35.6684092 Z'
							id='b05157c8-b93b-43b3-a4ba-0cfdfe0a562e-141'
							fill='#2F2E41'
							fillRule='nonzero'
						/>
						<path
							d='M15.9990706,52.6278641 C16.0937363,53.0453828 16.1554141,53.4697365 16.1835305,53.8969788 L49.3381287,73.0742816 L57.3965872,68.4227439 L65.9875879,79.6991233 L52.5195261,89.3241368 C50.2842101,90.9219563 47.2651724,90.8481682 45.1101602,89.1430449 L10.9190534,62.1004621 C7.7589952,63.2741043 4.20431856,62.3645253 1.99167703,59.8161042 C-0.220964505,57.2676831 -0.629752711,53.6123212 0.965027756,50.6358624 C2.55980822,47.6594036 5.82529789,45.9830884 9.16612688,46.4258884 C12.5069559,46.8686884 15.2258329,49.3381831 15.9944381,52.6278897 L15.9990706,52.6278641 Z'
							id='fb245157-e4e6-4551-ad6a-dca5f4b0f94b-142'
							fill='#FFB8B8'
							fillRule='nonzero'
						/>
						<path
							d='M50.4472046,73.9827523 L61.1630368,87.9072172 C61.7799655,88.7078997 62.713718,89.1999663 63.7213279,89.2553789 C64.7289378,89.3107916 65.7107652,88.9240708 66.4113341,88.195843 L78.5418004,75.566013 C81.3179313,73.5067654 82.7846025,70.1168548 82.3875064,66.6774497 C81.9904103,63.2380446 79.7901135,60.2737348 76.6181867,58.904839 C73.4462599,57.5359432 69.7864964,57.9712502 67.0220517,60.0462417 C66.9171785,60.1245039 66.8139259,60.2048672 66.7122937,60.2873317 L51.4984082,68.8166068 C50.6171102,69.311122 49.9941401,70.1657589 49.7918306,71.1578176 C49.5895211,72.1498762 49.8279106,73.1810951 50.4448799,73.9827608 L50.4472046,73.9827523 Z'
							id='b7c0657c-f78e-4619-b8ae-65b0c7791644-143'
							fill='#CBCBCB'
							fillRule='nonzero'
						/>
					</g>
					<polygon
						id='Path'
						fill='#A0616A'
						fillRule='nonzero'
						points='146.001677 416 156.16459 415.999145 161 376 146 376.000855'
					/>
					<path
						d='M143,413.000827 L163.15488,413 L163.155724,413 C170.249175,413.000388 175.999487,418.636719 176,425.58968 L176,425.9988 L143.000642,426 L143,413.000827 Z'
						id='Path'
						fill='#2F2E41'
						fillRule='nonzero'
					/>
					<polygon
						id='Path'
						fill='#A0616A'
						fillRule='nonzero'
						points='65 411.453796 75.1996353 413 86 374.28176 72.6282415 372'
					/>
					<path
						d='M62.9917145,408 L83.0191219,411.004645 L83.0199278,411.004772 C90.0684062,412.062923 94.9184542,418.591897 93.8533173,425.588322 L93.7906062,426 L61,421.080415 L62.9917145,408 Z'
						id='Path'
						fill='#2F2E41'
						fillRule='nonzero'
					/>
					<path
						d='M96.8395522,219 L107.989443,222.013 L107.247695,240.657041 L107.15575,274.602098 C109.404591,276.206274 110.460594,279.075156 109.810508,281.814376 C109.160422,284.553595 106.939055,286.595122 104.226062,286.946708 C101.513069,287.298295 98.8710431,285.887033 97.5840917,283.398841 C96.2971403,280.91065 96.6321384,277.861503 98.4262665,275.733383 L95,241.663982 L96.8395522,219 Z'
						id='Path'
						fill='#A0616A'
						fillRule='nonzero'
					/>
					<path
						d='M95.19641,197.183735 C95.323926,193.475432 97.5564864,190.185934 100.905794,188.771418 C104.042901,187.333755 107.713753,187.938436 110.252537,190.311062 C112.059897,191.965029 113.06386,194.350641 112.996847,196.832084 C113.026677,207.838171 110.600757,223.880517 110.576206,224.040959 L110.537449,224.296183 L94,230 L95.19641,197.183735 Z'
						id='Path'
						fill='#CBCBCB'
						fillRule='nonzero'
					/>
					<path
						d='M125.125,228.61513 L150.739043,222 L162.579169,261.785058 L163,410 L143.412868,409.877715 L135.225003,289.916542 L83.041661,400.762793 L62,398.243562 L107.87083,279.419681 C107.87083,279.419681 105.345833,258.426061 113.341663,247.929251 L111.658329,237.012571 L125.125,228.61513 Z'
						id='Path'
						fill='#2F2E41'
						fillRule='nonzero'
					/>
					<path
						d='M107.904052,237.567308 C107.183599,236.692089 106.879698,235.546949 107.071443,234.429924 L95.454212,199.597701 C94.3461456,196.270946 95.304882,192.604063 97.8997195,190.244359 L102.942937,185.662853 L106.360603,172 L126.003735,176.798784 L124.385318,183.268772 L133.275285,181.653927 L152,223.334319 L112.860429,238.969772 L110.932877,239 C109.759039,239.002079 108.646635,238.475893 107.904052,237.567308 Z'
						id='Path'
						fill='#CBCBCB'
						fillRule='nonzero'
					/>
					<path
						d='M135,208.569385 L146.270109,205 L155.540638,221.026336 L173.510719,249.517483 C176.313701,249.632449 178.754878,251.459007 179.647753,254.109387 C180.540629,256.759767 179.700047,259.684357 177.53456,261.461706 C175.369072,263.239055 172.327738,263.500592 169.88875,262.119201 C167.449763,260.737811 166.118897,257.999952 166.542999,255.23632 L145.456199,228.563806 L135,208.569385 Z'
						id='Path'
						fill='#A0616A'
						fillRule='nonzero'
					/>
					<path
						d='M122.288903,191.994315 C120.421258,188.834072 120.595125,184.886149 122.733529,181.898336 C124.677156,179.006539 128.169575,177.528488 131.627692,178.134175 C134.070878,178.537032 136.210392,179.983683 137.476054,182.088595 C143.371892,191.248049 149.833062,205.933195 149.897556,206.079982 L150,206.313712 L138.758495,220 L122.288903,191.994315 Z'
						id='Path'
						fill='#CBCBCB'
						fillRule='nonzero'
					/>
					<circle id='Oval' fill='#A0616A' fillRule='nonzero' cx='120.5' cy='154.5' r='15.5' />
					<circle id='Oval' fill='#2F2E41' fillRule='nonzero' cx='93' cy='132' r='15' />
					<path
						d='M79.7467912,144.82321 C83.7014073,147.629004 88.7958081,148.379915 93.4154677,146.837963 C98.0351274,145.296011 101.607342,141.652352 103,137.061742 C102.291891,142.589585 98.4777847,147.257059 93.1342975,149.134795 C87.7908104,151.01253 81.825708,149.781532 77.7047536,145.950653 C73.5837993,142.119773 72.0070714,136.339811 73.6263336,131 C72.939267,136.359543 75.2861359,141.660007 79.7467912,144.82321 Z'
						id='Path'
						fill='#2F2E41'
						fillRule='nonzero'
					/>
					<path
						d='M140,144.998449 C137.343028,140.241971 136.326367,138.255058 132.900519,135.362703 C129.871039,132.804702 126.144714,132.05399 123.139088,134.477257 C115.837709,131.322743 107.331403,133.334047 102.216209,139.424443 C97.1010152,145.514838 96.5897554,154.240281 100.958668,160.886329 C105.327582,167.532377 113.54079,170.52324 121.160617,168.242926 C128.780445,165.962612 134.000216,158.951787 133.999637,150.998468 C133.99693,150.318324 133.955988,149.63887 133.877005,148.963321 C136.489603,148.596446 137.387401,145.365368 140,144.998449 Z'
						id='Path'
						fill='#2F2E41'
						fillRule='nonzero'
					/>
					<rect id='Rectangle' fill='#CBCBCB' fillRule='nonzero' x='302' y='17' width='2' height='258' />
				</g>
			</g>
		</SvgIcon>
	);
};
